import { render, staticRenderFns } from "./SystemCouponDetail.vue?vue&type=template&id=6c51584d&scoped=true&"
import script from "./SystemCouponDetail.vue?vue&type=script&lang=js&"
export * from "./SystemCouponDetail.vue?vue&type=script&lang=js&"
import style0 from "./SystemCouponDetail.vue?vue&type=style&index=0&id=6c51584d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c51584d",
  null
  
)

export default component.exports